import { render, staticRenderFns } from "./016ceremonyVideo.vue?vue&type=template&id=38c5444c&"
import script from "./016ceremonyVideo.vue?vue&type=script&lang=js&"
export * from "./016ceremonyVideo.vue?vue&type=script&lang=js&"
import style0 from "./016ceremonyVideo.vue?vue&type=style&index=0&id=38c5444c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports